import Api from './api';

export const PaymentService = {
    createPreference: async (storeId: string, orderId: string, items: any[], customer: any, baseUrl: string) => {
        const { data } = await Api.post('/mercadopago/preference', {
            storeId, orderId, items, customer, baseUrl
        });
        return data;
    },

    createPixPayment: async (
        storeId: string,
        orderId: string | null,
        amount: number,
        payer: { name: string; phone: string },
        abandonedCartId?: string
    ) => {
        const { data } = await Api.post('/mercadopago/pix', { storeId, orderId, abandonedCartId, amount, payer });
        return data;
    },

    getPaymentStatus: async (storeId: string, paymentId: string) => {
        const { data } = await Api.get(`/mercadopago/payment/${storeId}/${paymentId}/status`);
        return data;
    },

    processCardPayment: async (storeId: string, orderId: string | null, formData: any, additionalData?: any, abandonedCartId?: string) => {
        const { data } = await Api.post('/mercadopago/card', { storeId, orderId, abandonedCartId, formData, additionalData });
        return data;
    },

    confirmPaymentFromClient: async (
        storeId: string,
        orderId: string | null,
        abandonedCartId: string | null,
        paymentId: string
    ): Promise<{ success: boolean; alreadyProcessed?: boolean; orderId?: string; orderNumber?: string }> => {
        const { data } = await Api.post('/mercadopago/confirm-payment-client', {
            storeId, orderId, abandonedCartId, paymentId
        });
        return data;
    },
};
